import router from '@/router';
import store from '@/store'
import { ref, watch }      from 'vue'
import { useDisplay } from 'vuetify'

export default {

    name: 'Bar',

    data: () => ({
        menu: false,
        showLogoutConfirm: false,
        pageName: 'Minhas Atividades Avaliativas',
        pessoal: [
            ['Dados', '/Usuario/DadosPessoais', 'mdi-account-details'],
            ['Segurança', '/Usuario/Seguranca', 'mdi-account-lock'],
        ],
        tbl: [
            ['Criar', '/Questionario/Criar', 'mdi-text-box-plus'],
            ['Listar', '/Questionarios/Listar', 'mdi-list-box'],
            ['Aplicar', '/Prova/Aplicar', 'mdi-note'],
            ['Dashboard Turma', '/Provas/Listar', 'mdi-view-dashboard'],
            ['Dashboard Individual', '/Provas/DashboardIndividual', 'mdi-chart-box-outline'],
            ['Repositório', '/Repositorios/Listar', 'mdi-folder-question'],
        ],
        avaliacaoDiscursivaProf: [
            ['Adicionar Avaliação', '/AvaliacaoDiscursiva/Professor', 'mdi-text-box-edit'],
            ['Consultar protocolo', '/AvaliacaoDiscursiva/ConsultarProtocolo', 'mdi-magnify'],
            ['Admin', '/AvaliacaoDiscursiva/Admin', 'mdi-shield-account'],
        ],
        estatisticaTurmaProf: [
            ['Geral', '/AvaliacaoDiscursiva/EstatisticaTurma/Geral', 'mdi-chart-box'],
            ['Individual', '/AvaliacaoDiscursiva/EstatisticaTurma/Individual', 'mdi-account-group'],
        ],
        osceProf: [
            ['4o. ao 8o. Períodos', '/OSCE/Formulario', 'mdi-clipboard-edit'],
            ['9o. ao 12o. Períodos', '/OSCE/9o-12o', 'mdi-clipboard-text'],
            ['Histórico', '/OSCE/Historico', 'mdi-history'],
        ],
        avaliacaoDiscursivaAluno: [
            ['Aluno', '/AvaliacaoDiscursiva/Aluno', 'mdi-pencil'],
            ['Consulta prova', '/AvaliacaoDiscursiva/ConsultaProva', 'mdi-clipboard-check'],
        ],
        osceAluno: [
            ['OSCE', '/OSCE/Aluno', 'mdi-clipboard-check'],
        ],
        salaAula: [
            ['Entrar', '/Aluno/Prova', 'mdi-login'],
            ['Dashboard TBL', '/aProvas/Listar', 'mdi-note-text'],
        ],
    }),

    setup() {
        const { mobile }  = useDisplay();
        const showNavIcon = ref(true);

        showNavIcon.value = true;

        watch(mobile, () => {
            showNavIcon.value = true;
        });

        return { showNavIcon }
    },

    mounted() {
        this.getTitleBar();
    },

    computed: {
        currentParamsPage() {
            return this.$route.params;
        },

        avaliacaoDiscursivaItems() {
            if (store.state.userType === 'coordenador') {
                return this.avaliacaoDiscursivaProf.filter(
                    ([title]) => title !== 'Adicionar Avaliação'
                );
            }

            return this.avaliacaoDiscursivaProf;
        }
    },

    watch: {
        currentParamsPage(newVal, oldVal) {
            this.getTitleBar();
            this.menu = false;
        }
    },

    methods: {

        getUserName() {
            let pt    = '';
            let names = store.state.userName.split(' ');

            if (store.state.userType === 'professor') {
                if (store.state.userSex === 'm' || store.state.userSex === 'ni') {pt = 'Prof.: '}
                else if (store.state.userSex === 'f') {pt = 'Profa.: '}
            }
            else if (store.state.userType === 'aluno') {
                if (store.state.userSex === 'm' || store.state.userSex === 'ni') {pt = 'Aluno: '}
                else if (store.state.userSex === 'f') {pt = 'Aluna: '}
            }
            else if (store.state.userType === 'administrador_sistema') {
                pt = 'Admin: ';
            }
            else if (store.state.userType === 'coordenador') {
                pt = 'Coord.: ';
            }

            let name = pt.concat(names[0]);

            return name;
        },

        getTitleBar() {
            if (Object.keys(this.$route.params).length === 0 && store.state.userType === 'professor') { this.pageName = 'Painel' }
            if (Object.keys(this.$route.params).length === 0 && store.state.userType === 'aluno') { this.pageName = 'TBL' }
            if (this.$route.name === 'materiais') { this.pageName = 'Materiais' }
            if (this.$route.params.uPage === 'DadosPessoais') { this.pageName = 'Dados Pessoais' }
            if (this.$route.params.uPage === 'Seguranca') { this.pageName = 'Segurança' }
            if (this.$route.params.qPage === 'Listar') { this.pageName = 'Meus Questionários' }
            if (this.$route.params.qPage === 'Criar') { this.pageName = 'Novo Questionário' }
            if (this.$route.params.qPage === 'Editar') { this.pageName = 'Editar Questionário' }
            if (this.$route.params.pPage === 'Aplicar') { this.pageName = 'Escolha do Questionário' }
            if (this.$route.params.pPage === 'Aplicar' && this.$route.params.id) { this.pageName = 'Aplicação da Atividade Avaliativa' }
            if (this.$route.params.pPage === 'Prova') { this.pageName = 'Atividade Avaliativa' }
            if (this.$route.params.psPage === 'Listar') { this.pageName = 'Atividades Avaliativas Aplicadas' }
            if (this.$route.params.psPage === 'Notas') { this.pageName = 'Dashboard Turma' }
            if (this.$route.name === 'tblDashboardIndividual') { this.pageName = 'Dashboard Individual' }
            if (this.$route.params.psPage === 'Estatisticas') { this.pageName = 'Estatísticas da Atividade Avaliativa' }
            if (this.$route.params.rPage === 'Listar') { this.pageName = 'Repositório de Questões' }
            if (this.$route.params.aPage === 'Prova') { this.pageName = 'TBL' }
            if (this.$route.params.aPage === 'Prova' && this.$route.params.id) { this.pageName = 'Atividade Avaliativa' }
            if (this.$route.params.anPage === 'Listar') { this.pageName = 'Minhas Atividades Avaliativas' }
            if (this.$route.params.anPage === 'Notas') { this.pageName = 'Resultado da Atividade Avaliativa' }
            if (this.$route.params.dPage === 'Professor') { this.pageName = 'Adicionar Avaliação' }
            if (this.$route.params.dPage === 'ConsultarProtocolo') { this.pageName = 'Consultar Protocolo' }
            if (this.$route.params.dPage === 'Admin') { this.pageName = 'Administração da Avaliação Discursiva' }
            if (this.$route.params.dPage === 'EstatisticaTurma') { this.pageName = 'Estatísticas da Turma' }
            if (this.$route.params.dPage === 'Aluno' && this.$route.params.subPage === 'Dashboard') { this.pageName = 'Dashboard Acadêmico' }
            if (this.$route.name === 'alunoDashboard') { this.pageName = 'Dashboard Acadêmico' }
            if (this.$route.name === 'adminSistema') { this.pageName = 'Administração do Sistema' }
            if (this.$route.params.dPage === 'Aluno' && this.$route.params.subPage !== 'Dashboard') { this.pageName = 'Avaliação Discursiva' }
            if (this.$route.params.dPage === 'ConsultaProva') { this.pageName = 'Consulta Prova' }
        },

        logout() {
            this.menu = false;
            this.showLogoutConfirm = true;
        },

        confirmLogout() {
            this.showLogoutConfirm = false;
            localStorage.removeItem('token');
            router.push({ name: 'login' });
        },

        toggleDrawer() {
            this.$store.commit('toggleDrawerState')
        },

    }
};
